import { Link } from "react-router-dom";
import { useUserProfile } from "../../contexts/UserProfileContext";

export default function AdminPacklistOverview() {
  const { profile } = useUserProfile();

  if (!profile || profile.role !== "admin") {
    return (
      <div className="text-center text-red-400 mt-10">
        Kein Zugriff – nur für Admins 🛑
      </div>
    );
  }

  return (
    <div className="max-w-4xl mx-auto mt-10 p-6">
      <h1 className="text-2xl font-bold text-sky-400 mb-6">
        🎒 Packlisten verwalten
      </h1>
      <p className="mb-8 text-slate-400">
        Verwalte Kategorien, Tags und Vorlagen für persönliche Packlisten.
      </p>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
        <Link
          to="/admin/packlists/categories"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">📂 Kategorien</h2>
          <p className="text-slate-400">
            Kleidung, Beauty, Technik, Dokumente …
          </p>
        </Link>

        <Link
          to="/admin/packlists/tags"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">🏷️ Tags</h2>
          <p className="text-slate-400">
            Strand, Aktiv, Allgemein – wofür ist das Item geeignet?
          </p>
        </Link>
        <Link
          to="/admin/packlist-items"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">📦 Items verwalten</h2>
          <p className="text-slate-400">
            Zentrale Pflege aller verfügbaren Packlisten-Items.
          </p>
        </Link>

        <Link
          to="/admin/packlists/templates"
          className="block bg-[#161b27] border border-[#2a3347] rounded-lg p-6 hover:border-sky-500/20 transition-colors"
        >
          <h2 className="text-xl font-semibold mb-2 text-slate-100">📑 Vorlagen</h2>
          <p className="text-slate-400">
            Packlisten-Vorlagen wie „Strandurlaub" oder „Camping" verwalten.
          </p>
        </Link>
      </div>
    </div>
  );
}
